"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = /*#__PURE__*/_react["default"].createElement("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react["default"].createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.93732 0.00830233C0.917039 0.00846973 0.0317383 0.808902 0.0317383 1.83966V10.8309C0.0317383 11.2687 0.282543 11.6459 0.655767 11.8521C1.04665 12.0681 1.59995 12.0534 1.95833 11.7705L4.7687 9.5517L7.5976 11.7714C7.78801 11.9208 8.12529 11.9857 8.36345 11.9857C9.01107 11.9857 9.50376 11.4524 9.50376 10.7944V5.82175H11.6998C11.8655 5.82175 11.9998 5.68743 11.9998 5.52175V1.74902C11.9998 0.782525 11.2163 -0.000976562 10.2498 -0.000976562C7.479 -0.000976562 4.70815 0.005188 1.93732 0.00830233ZM8.66741 1.00074L1.93789 1.0083C1.41794 1.0083 1.03174 1.4115 1.03174 1.83966V10.8309C1.03174 10.9951 1.25222 11.0266 1.3641 10.9655L4.45792 8.52297C4.63914 8.37991 4.89475 8.37952 5.0764 8.52205L8.1884 10.9639C8.31505 11.0281 8.50376 10.9542 8.50376 10.7944V5.82175H8.49982V1.74902C8.49982 1.4813 8.55994 1.22762 8.66741 1.00074ZM9.50376 4.82175L9.49982 1.74902C9.49982 1.33481 9.8356 0.999023 10.2498 0.999023C10.664 0.999023 10.9998 1.33481 10.9998 1.74902V4.82175H9.50376Z"
}));

exports["default"] = _default;